export const MUT_SET_POSTAL_ADDRESS_SELECTED = 'MUT_SET_POSTAL_ADDRESS_SELECTED';
export const MUT_SET_SECOND_PERSON_SELECTED = 'MUT_SET_SECOND_PERSON_SELECTED';
export const MUT_SET_EMAIL = 'MUT_SET_EMAIL';
export const MUT_SET_FIRST_NAME = 'MUT_SET_FIRST_NAME';
export const MUT_SET_LAST_NAME = 'MUT_SET_LAST_NAME';
export const MUT_RESET = 'MUT_RESET';
export const MUT_LOAD_STATE = 'MUT_LOAD_STATE';

